// @flow

import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { isRTL } from 'app/utils/lang';
import logo from './assets/tv-logo.png';
import Styles from './styles';

export default () => {
  const { t, i18n } = useTranslation();

  return (
    <Styles className={`${isRTL() ? 'rtl' : ''}`}>
      <img src={logo} alt="logo" />
      <h3>
        {t('Containers.Mobile.description', { app: _.get(process.env.APP_CONFIG, ['APP_DETAILS', `${(i18n.language).toUpperCase()}_NAME`]) })}
      </h3>
      <a
        href={_.get(process.env.APP_CONFIG, ['APP_GLOBAL_CONFIG', 'APPS_URL'], '')}
        target="_blank"
        rel="noopener noreferrer"
        className="appsLink"
      >
        <p>
          {t('Containers.Mobile.apps', { app: _.get(process.env.APP_CONFIG, ['APP_DETAILS', `${(i18n.language).toUpperCase()}_NAME`]) })}
        </p>
        <i className="fa fa-android" />
        <i className="fa fa-apple" />
      </a>
    </Styles>
  );
};
